<template>
	<div>
		<a-button @click="alert" type="primary" size="mini" circle>在线编辑</a-button>
	</div>
</template>


<script>
	import axios from 'axios'
	import {
		officefile
	} from '@/api/assetmenag'
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import storage from 'store'
	export default {
		data() {
			return {
				pageofficepath: "",
			}
		},
		created() {
			const s = document.createElement('script');
			s.type = 'text/javascript';
			s.src = 'https://xcx.uv8000.org/uv/pageoffice.js';
			s.onload = s.onreadystatechange = () => {
				const tok = storage.get(ACCESS_TOKEN)
				console.log(tok,POBrowser,1212)
				POBrowser.headerToken = "Authorization:" + tok
			}
			document.body.appendChild(s);
		},
		mounted() {
			
		},
		methods: {
			alert() {
				this.pageofficepath = 'txt/20220124210239588896.doc'
				axios.get('https://xcx.uv8000.org/uv/api/office/file?path=txt/20220219162128681803.doc', {
					params: {
						'key': 'value'
					},
					headers: {
						Authorization: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzb25neGlhb3FpbiIsImV4cCI6MTY3NDY3MjA1NH0.HBrUF8-O9I4eECj2cPuC3JJB7wZNnLOTM1jEx3634ZEtO2vftMSC7SK4OJVHhJ6xBkufabx-5Hvke3jcJZUl-w'
					}
				}).then(function(response) {
					console.log(response)
				}).catch(function(error) {
					alert(error);
				});
				this.$nextTick(() => {
					this.tap()
				})
			},
			tap() {
				var a = document.createElement('a');
				var pageofficepath = this.pageofficepath
				var last =
					`javascript:POBrowser.openWindowModeless('https://xcx.uv8000.org/uv/api/office/file?path=${pageofficepath}')`
				a.href = last
				a.click()
			},
		}
	}
</script>

<style>
</style>
